module.exports = __webpack_public_path__ + "static/media/rtpm-icon-white.49c186a6.png";